import styles from './LinkPSP.module.scss';

export default function LinkPSP({ config }) {
    return (
        <a
            id="linkpsp"
            href={config?.link}
            className={styles.linkpsp}
            target="_blank"
            rel="noopener noreferrer">
            <img src={config?.button_image} style={{ maxHeight: config?.height }}/>
        </a>
    );
}
